import { AxiosResponse } from 'axios';

import { TSearchParams } from '../../hooks/useSearch';
import instance from '../Axios/instance';

class SearchService {
  /**
     * GetTableData - retrieves table data based on the
     * url provided including the query strings which consist of the search criteria
     */
  public static async GetTableData<T>(searchParams: TSearchParams): Promise<T> {
    const response: AxiosResponse<T> = await instance({
      method: 'GET',
      url: searchParams.baseUrl,
      params: { ...searchParams.queryParams },
      data: searchParams.body,
    });

    return response.data;
  }
}

export default SearchService;
